import { sleep } from "@/shared/utils";
import { MutationConfig, MutationResult } from "@/shared/types/base";
import { api } from "@/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ReactNode } from "react";
import { CuentaCorrienteItem, CuentaCorrienteItemTipo } from "@/shared/types/cuenta-corriente";

export interface CuentaCorrienteItemRequest {
    tipo: CuentaCorrienteItemTipo,
    fecha?: string,
    descripcion?: string,
    debe: number,
    haber: number
}

export async function addCuentaCorrienteItem(personaId: string, request: CuentaCorrienteItemRequest): Promise<CuentaCorrienteItem> {
    await sleep(1000);
    const response = await api.post("cuenta_corrientes/" + personaId + "/items", request);
    return response.data;
}

export function useAddCuentaCorrienteItemMutation(personaId: string, mutationConfig: MutationConfig<CuentaCorrienteItem, CuentaCorrienteItemRequest> = {}) {
    const queryClient = useQueryClient();
    return useMutation({
        ...mutationConfig,
        mutationFn: request => addCuentaCorrienteItem(personaId, request),
        onSuccess: (...args) => {
            mutationConfig.onSuccess && mutationConfig.onSuccess(...args);
            queryClient.invalidateQueries({ queryKey: ["cuenta_corrientes", personaId, "items"] });
        },
    })
}

export interface AddCuentaCorrienteItemMutationProps {
    personaId: string,
    mutationConfig?: MutationConfig<CuentaCorrienteItem, CuentaCorrienteItemRequest>
    children?: (mutationResult: MutationResult<CuentaCorrienteItem, CuentaCorrienteItemRequest>) => ReactNode
}

export function AddCuentaCorrienteItemMutation({
    personaId,
    mutationConfig,
    children
}: AddCuentaCorrienteItemMutationProps) {
    const mutationResult = useAddCuentaCorrienteItemMutation(personaId, mutationConfig);
    return children && children(mutationResult);
}